const locales = {
    nl: require('pwstrength-bootstrap/locales/nl.json'),
    en: require('pwstrength-bootstrap/locales/en.json'),
    de: require('pwstrength-bootstrap/locales/de.json'),
    fr: require('pwstrength-bootstrap/locales/fr.json'),
    es: require('pwstrength-bootstrap/locales/es.json'),
    it: require('pwstrength-bootstrap/locales/it.json'),
};

export const setupPwStrengthTranslator = (locale = 'en') => {
    const messages = locales[locale] || locales.en;

    return (key) => {
        'use strict';
        return messages[key] !== key ? messages[key] || '' : '';
    };
};
